// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + {"166":"8505a36625","457":"f0faa2aef7"}[chunkId] + ".min.css";
};